import { styled } from "@mui/material";

export const NoPrint = styled("div")({
  "@media print": {
    display: "none",
  },
});
